import { isPortalApiError } from '@afterpaytouch/portal-api'
import { ErrorCode } from '@afterpaytouch/portal-api/types'
import { CheckoutError, checkoutErrors, TerminalErrorCode } from '../../../model'
import { CHECKOUT_FLOW_TYPE, postCheckoutFlowMessage } from '../../../integrations/inappbrowser-messenger'
import { capture } from '@afterpaytouch/integrations/monitoring'

export const handleInitialiseError = (error: unknown): CheckoutError => {
  if (isPortalApiError(error)) {
    const knownError = checkoutErrors[error.errorCode]
    const portalApiError = {
      error: knownError ?? TerminalErrorCode.Default,
      errorCode: error.errorCode ?? ErrorCode.Error,
    }
    postCheckoutFlowMessage(CHECKOUT_FLOW_TYPE.ON_CHECKOUT_ERROR, portalApiError)
    return portalApiError
  }

  if (error instanceof Error) {
    capture.error(error)
  } else {
    capture.error('Error during initialise', error as Record<string, unknown>)
  }

  const terminalError = {
    error: TerminalErrorCode.Default,
    errorCode: ErrorCode.Error,
  }
  postCheckoutFlowMessage(CHECKOUT_FLOW_TYPE.ON_CHECKOUT_ERROR, terminalError)
  return terminalError
}
